class SizePasform extends HTMLElement {
    constructor() {
        super();

        this.items = this.querySelectorAll(".size-pasform__bar-item");
        this.helperItems = this.querySelectorAll(".size-pasform__helper-item");

        if (!this.dataset.selectedIndex) {
            this.classList.add("visually-hidden");
            return;
        }
        this.selectedIndex = parseInt(this.dataset.selectedIndex) - 1;

        this.init();
    }

    init() {
        this.selectItem(this.selectedIndex);
    }

    selectItem(index) {
        this.items[this.selectedIndex].classList.add("selected");
        this.helperItems[this.selectedIndex].classList.remove("visually-hidden");
    }
}

window.customElements.define('size-pasform', SizePasform);